import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { FormControl, RadioGroup, FormControlLabel, Radio, CircularProgress, Select, Typography, Checkbox } from '@material-ui/core';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { Elements, CardElement, ElementsConsumer } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import PaymentDetails from './PaymentDetails';

import Payment from '../../models/Payment';
import { PaymentType } from '../../models/PaymentType.enum';
import { UserRoleType } from '../../models/User';
import ManualEntryEdit from '../../models/ManualEntryEdit';
import CartCalculations from '../../models/CartCalculation';
import GhaFwdConfigModel from '../../models/GhaFwdConfig';
import ForwarderInvoiceBalance from '../../models/ForwarderGhaInvoiceBalance';

import './cardSectionStyles.css';
import paymentPageStyles from './paymentPage.module.css';
import commonStyles from '../common/common.module.css';

import CcImg from '../../assets/payment_methods/cc.png';

import { formatCurrency } from '../../utils/currencyFormatter';

import environments from '../../configs/environments';
import AlternativePaymentOptions, { KeyValue } from '../../models/PaymentOptions';
import { paymentOptions } from '../../utils/paymentTypes';
import PaymentDetailsCredit from './PaymentDetailsCredit';
import { red } from '@material-ui/core/colors';

const styles = (theme: any) => ({
  play: {
    marginTop: 20
  },
  playRotate: {
    transform: 'rotate(90deg)'
  },
  cursor: {
    cursor: 'pointer'
  },
  listItem: {
    paddingBottom: 5,
    display: 'flex'
  },
  collapseWrapper: {
    width: '100%'
  },
  inputLabel: {
    color: 'black',
    marginRight: '2%'
  },
  select: {
    '& [class^="MuiSelect-select-"]': {
      padding: '11px 35px 11px 14px',
      color: 'var(--primaryblue)'
    },
    width: '157px'
  },
  textField: {
    flexGrow: 1,
    '& .MuiOutlinedInput-multiline-132': {
      padding: '10px 12px !important',
    },
  },
  paymentInfo: {
    minWidth: '50%',
    '& input': {
      padding: '10px 12px',
    },
    '& label': {
      transform: 'translate(14px, 11px) scale(1)',
    }
  },
  styleInputProps: {
    color: 'var(--primaryblue)',
    fontSize: '0.8125rem'
  },
  button: {
    width: '200px'
  },
  creditCardButton: {
    width: '200px',
    '& :first-child': {
      marginTop: '0px !important'
    }
  },
  ghaLabel: {
    marginTop: '20px'
  },
  formControlLabel: {
    marginBottom: '20px',
    paddingBottom: '20px',
    borderBottom: '1px solid #d4d4d4',
    '&:last-child': {
      borderBottom: 'none',
    }
  },
  progress: {
    marginTop: '32px',
    animation: 'none'
  },
  formControlLabelCc: {
    marginBottom: '20px',
    alignItems: 'flex-start',
  },
  '@media (max-width:600px)': {
    inputLabel: {
      marginBottom: '10px'
    },
    paymentInfo: {
      minWidth: '85%',
      marginLeft: '40px',
    }
  },
  balanceContainer: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1),
  },
  balanceText: {
    marginRight: theme.spacing(1),
  },
  green: {
    color: 'green'
  },
  red: {
    color: 'red'
  }
});

interface PaymentPageProps {
  classes: any;
  disabledPay: boolean;
  due: number;
  paymentInfoSelect: string;
  isGeneratePickUpOrder: boolean;
  handlePay: (generatePO: boolean, stripePaymentMethodId?: string, redirectToOrder?: boolean) => void;
  openNoPoPayConfirmation: () => void;
  expandPrevPayments: boolean;
  handleChange: (event: any, propertyName?: string) => void;
  payments: Array<Payment>;
  paymentInfo: string;
  paymentType: string;
  handleChangePaymentType: (event: any) => void;
  ghaFwdConfig: GhaFwdConfigModel;
  handleClickTextField: (event: any) => void;
  userRole: UserRoleType;
  fwdInvoiceBalance: ForwarderInvoiceBalance;
  handleStripePayment: Function;
  verifiedAchPayment: boolean;
  cartCalculations: CartCalculations;
  errorMessageCardElement: string;
  onChangeCardElement: (event: any) => void;
  disableStripeBtn: boolean;
  manualEntryEdit: ManualEntryEdit;
  redirectToPickupOrder: () => void;
  disableButton: boolean;
  paymentOptions: AlternativePaymentOptions;
  comat?: boolean;
  applyEwalletBalance: boolean;
  ewalletBalance: ForwarderInvoiceBalance;
  checkWalletBalance: (event: any) => void;
};

const paymentPage = (props: PaymentPageProps) => {

  const disableWalletCheck = props.ewalletBalance.balance < 1 || props.ewalletBalance.balance >= props.cartCalculations.remainDue;
  let payOptions: Array<JSX.Element> = [];

  if (props.paymentOptions.options) {
    payOptions = props.paymentOptions.options.options.map((item: any, index: number) => {
      return (
        <option key={index} value={item.value}>{item.name}</option>
      );
    });
  } else[
    payOptions = paymentOptions.map((item: any, index: number) => {
      return (
        <option key={index} value={item.value}>{item.name}</option>
      );
    })
  ]

  const { classes } = props;
  const disableOther = props.paymentInfoSelect === 'other' && props.paymentInfo ? true : false;
  const disablePayButton: boolean = props.paymentInfoSelect && props.paymentInfoSelect !== 'other' || disableOther ? true : false;
  const disableButton: boolean = props.disabledPay || props.paymentType === '' || (props.paymentType === PaymentType.ALTERNATIVE_PAYMENT && (!disablePayButton && props.userRole !== UserRoleType.FORWARDER)) || props.disableButton || (props.paymentInfoSelect === 'eWallet' && props.ewalletBalance.balance < props.due);
  const totalConvenienceInvoicePayment: number = props.userRole === UserRoleType.FORWARDER || props.ghaFwdConfig ? (props.ghaFwdConfig && props.ghaFwdConfig.pay_by_invoice_allowed ? props.cartCalculations.itemsCount * props.ghaFwdConfig.convenience_fee_usd : 0) : 0;
  const totalPayInvoicePayment: number = totalConvenienceInvoicePayment + props.due;
  const showStripeComponent: boolean = props.paymentType === PaymentType.CREDIT_CARD;
  const cardStyles = {
    style: {
      base: {
        fontSize: "16px"
      }
    }
  };

  function disableAccountPayment(): boolean {

    if (props.fwdInvoiceBalance.balance - totalPayInvoicePayment < 0) {
      return true;
    }

    return false;
  };


  return (
    <div className={`${commonStyles.wrapper}`}>
      <div className={`${paymentPageStyles.pageWrapper} `}>
        {(props.due > 0 || props.comat) &&
          <Fragment >
            {props.userRole === UserRoleType.FORWARDER &&
              <FormControl >
                <RadioGroup
                  aria-label="payment_method"
                  name="payment_method"
                  value={props.paymentType}
                  onChange={props.handleChangePaymentType}
                  className={commonStyles.w100}
                >
                  {props.cartCalculations.creditCart &&
                    <FormControlLabel
                      value={PaymentType.CREDIT_CARD}
                      control={<Radio color="primary" className={classes.radio} />}
                      className={`${classes.formControlLabelCc} ${classes.formControlLabel}`}
                      classes={{ label: commonStyles.w100 }}
                      label={
                        <Typography className={commonStyles.w100}>
                          <div className={`${paymentPageStyles.itemsWrapper} ${commonStyles.w100}`}>
                            <div className={paymentPageStyles.radioLabels}>
                              <div className={paymentPageStyles.creditCartRadioLabel}>Pay via Credit Card</div>
                              <div><img className={paymentPageStyles.img} src={CcImg} alt="payment card" /></div>
                            </div >
                            {props.paymentType === PaymentType.CREDIT_CARD &&
                              <div onClick={disableWalletCheck ? () => { } : (event: any) => {
                                props.checkWalletBalance(event);
                              }}>
                                <FormControlLabel
                                  key={'all'}
                                  label={"Apply E wallet balance"}
                                  control={
                                    <Checkbox
                                      checked={props.applyEwalletBalance && props.paymentType === PaymentType.CREDIT_CARD}
                                      onChange={disableWalletCheck ? () => { } : (event: any) => {
                                        props.checkWalletBalance(event);
                                      }}// Stop event propagation
                                      color="primary"
                                      className={props.classes.checkbox}
                                      disabled={disableWalletCheck}
                                      icon={<CheckBoxOutlineBlankIcon className={props.classes.sizeIcon} />}
                                      checkedIcon={<CheckBoxIcon className={props.classes.sizeIcon} />}
                                    />
                                  }
                                // className={ props.classes.formControlLabel }
                                />
                                <div className={classes.balanceContainer}>
                                  <Typography className={classes.balanceText}>Available Balance:</Typography>
                                  <Typography>{props.ewalletBalance.balance}</Typography>
                                </div>
                              </div>
                            }

                            {props.cartCalculations.creditCart &&
                              <PaymentDetails
                                due={formatCurrency((props.cartCalculations.remainDue), 2)}
                                items={props.cartCalculations.itemsCount}
                                totalPay={ props.cartCalculations.creditCart.ccTotal }
                                disabled={false}
                                totalConvenience={formatCurrency(props.cartCalculations.creditCart.convenienceFee, 2)}
                                stripeTax={props.cartCalculations.creditCart.stripeTax ? formatCurrency(props.cartCalculations.creditCart.stripeTax, 2) : undefined}
                                textConvenienceFee={`Convenience fee for ${props.cartCalculations.itemsCount} AWBS:`}
                                applyEwallet={props.applyEwalletBalance && props.paymentType === PaymentType.CREDIT_CARD}
                                eWalletAmount={props.ewalletBalance.balance.toString()}
                              />
                            }
                          </div>
                          {showStripeComponent &&
                            <div className={paymentPageStyles.elements}>
                              <Elements stripe={loadStripe(environments.stripeApiKey)}>
                                <CardElement options={cardStyles} onChange={props.onChangeCardElement} />
                                <div className={paymentPageStyles.errorMessageCardElement}>
                                  {props.errorMessageCardElement &&
                                    <div >{props.errorMessageCardElement}</div>
                                  }
                                </div>
                                <ElementsConsumer>
                                  {({ stripe, elements }) => (
                                    <div className={paymentPageStyles.elementsConsumerWrapper}>
                                      <Button
                                        variant='contained'
                                        color='primary'
                                        className={classes.creditCardButton}
                                        disabled={props.disableStripeBtn}
                                        onClick={() => { props.handleStripePayment(stripe, elements, true) }}
                                      >
                                        {props.userRole === UserRoleType.FORWARDER ? 'Update' : 'Pay & Generate PO'}
                                      </Button>
                                      {props.userRole !== UserRoleType.FORWARDER && <Button
                                        variant='contained'
                                        color='primary'
                                        className={classes.creditCardButton}
                                        disabled={props.disableStripeBtn}
                                        onClick={() => { props.handleStripePayment(stripe, elements, false) }}
                                      >
                                        Pay & Exit
                                      </Button>}
                                    </div>
                                  )}
                                </ElementsConsumer>
                              </Elements>
                            </div>
                          }
                        </Typography>
                      }
                    />
                  }

                  {props.cartCalculations.ach &&
                    <FormControlLabel
                      disabled={!props.verifiedAchPayment}
                      value={PaymentType.ACH}
                      control={<Radio color="primary" className={classes.radio} />}
                      className={classes.formControlLabel}
                      classes={{ label: commonStyles.w100 }}
                      label={
                        <div className={[paymentPageStyles.itemsWrapper, !props.verifiedAchPayment ? paymentPageStyles.disabledLabelColor : ''].join(' ')}>
                          <div className={paymentPageStyles.radioLabels}>
                            <div className={paymentPageStyles.creditCartRadioLabel}>Pay via ACH</div>
                            {!props.verifiedAchPayment &&
                              <div className={paymentPageStyles.invoiceInfo}>You do not have a verified bank account.</div>
                            }
                          </div>
                          {props.paymentType === PaymentType.ACH && <FormControlLabel
                            key={'all'}
                            label={"Apply E wallet balance"}
                            control={
                              <Checkbox
                                checked={props.applyEwalletBalance && props.paymentType === PaymentType.ACH}
                                // onChange={ () => props.updateGoodsValue() }
                                color="primary"
                                className={props.classes.checkbox}
                                icon={<CheckBoxOutlineBlankIcon className={props.classes.sizeIcon} />}
                                checkedIcon={<CheckBoxIcon className={props.classes.sizeIcon} />}
                              />
                            }
                          // className={ props.classes.formControlLabel }
                          />}
                          {props.cartCalculations.ach &&
                            <PaymentDetails
                              due={formatCurrency(props.cartCalculations.remainDue, 2)}
                              items={props.cartCalculations.itemsCount}
                              totalPay={props.cartCalculations.ach.achTotal}
                              disabled={!props.verifiedAchPayment}
                              totalConvenience={formatCurrency(props.cartCalculations.itemsCount * props.cartCalculations.ach.convenienceFee, 2)}
                              textConvenienceFee={`Convenience fee $${props.cartCalculations.ach.convenienceFee}  X ${props.cartCalculations.itemsCount} AWBS:`}
                              applyEwallet={props.applyEwalletBalance && props.paymentType === PaymentType.ACH}
                              eWalletAmount={props.ewalletBalance.balance.toString()}
                            />
                          }
                        </div>
                      }
                    />
                  }

                  {props.ghaFwdConfig && props.ghaFwdConfig.pay_by_invoice_allowed &&
                    <FormControlLabel
                      value={PaymentType.INVOICE_PAYMENT}
                      control={<Radio color="primary" />}
                      className={`${classes.formControlLabelAfter} ${classes.formControlLabel}`}
                      classes={{ label: commonStyles.w100 }}
                      disabled={disableAccountPayment()}
                      label={
                        <div className={paymentPageStyles.itemsWrapper}>
                          <div className={[paymentPageStyles.radioLabels, disableAccountPayment() ? paymentPageStyles.disabledLabelColor : ''].join(' ')}>
                            <div>Pay via {props.fwdInvoiceBalance.accountType}</div>
                            <div className={paymentPageStyles.invoiceInfo}>This option will add {formatCurrency(+props.ghaFwdConfig.convenience_fee_usd, 2, '$')} convenience fee per awb</div>
                          </div>
                          {props.paymentType === PaymentType.INVOICE_PAYMENT && <div onClick={disableWalletCheck ? () => { } : (event: any) => {
                            props.checkWalletBalance(event);
                          }}>
                            <FormControlLabel
                              key={'all'}
                              label={"Apply E wallet balance"}
                              control={
                                <Checkbox
                                  checked={props.applyEwalletBalance && props.paymentType === PaymentType.INVOICE_PAYMENT}
                                  // Stop event propagation
                                  color="primary"
                                  className={props.classes.checkbox}
                                  disabled={disableWalletCheck}
                                  icon={<CheckBoxOutlineBlankIcon className={props.classes.sizeIcon} />}
                                  checkedIcon={<CheckBoxIcon className={props.classes.sizeIcon} />}
                                />
                              }
                            // className={ props.classes.formControlLabel }
                            />
                            <div className={classes.balanceContainer}>
                              <Typography className={classes.balanceText}>Available Balance:</Typography>
                              <Typography>{props.ewalletBalance.balance}</Typography>
                            </div>
                          </div>}
                          <PaymentDetailsCredit
                            due={formatCurrency(props.due, 2)}
                            items={props.cartCalculations.itemsCount}
                            totalPay={formatCurrency(totalPayInvoicePayment, 2)}
                            disabled={disableAccountPayment()}
                            fwdInvoiceBalance={props.fwdInvoiceBalance.balance}
                            totalConvenience={formatCurrency(totalConvenienceInvoicePayment, 2)}
                            type={props.userRole}
                            textConvenienceFee={`Convenience fee $${props.ghaFwdConfig.convenience_fee_usd}  X ${props.cartCalculations.itemsCount} AWBS:`}
                            applyEwallet={props.applyEwalletBalance && props.paymentType === PaymentType.INVOICE_PAYMENT}
                            eWalletAmount={props.ewalletBalance.balance.toString()}
                            paymentType={ PaymentType.INVOICE_PAYMENT }
                          />
                        </div>
                      }
                    />
                  }

                  {props.ghaFwdConfig && props.ghaFwdConfig.pay_by_wallet &&
                    <FormControlLabel
                      value={PaymentType.E_WALLET_PAYMENT}
                      control={<Radio color="primary" />}
                      className={`${classes.formControlLabelAfter} ${classes.formControlLabel}`}
                      classes={{ label: commonStyles.w100 }}
                      disabled={props.ewalletBalance.balance < props.cartCalculations.remainDue}
                      label={
                        <div className={paymentPageStyles.itemsWrapper}>
                          <div className={[paymentPageStyles.radioLabels, props.ewalletBalance.balance < props.cartCalculations.remainDue ? paymentPageStyles.disabledLabelColor : ''].join(' ')}>
                            <div>Pay via E Wallet </div>
                          </div>
                          <PaymentDetailsCredit
                            due={formatCurrency(props.due, 2)}
                            items={props.cartCalculations.itemsCount}
                            totalPay={formatCurrency(totalPayInvoicePayment, 2)}
                            disabled={props.ewalletBalance.balance < props.cartCalculations.remainDue}
                            fwdInvoiceBalance={props.fwdInvoiceBalance.balance}
                            totalConvenience={formatCurrency(totalConvenienceInvoicePayment, 2)}
                            type={props.userRole}
                            textConvenienceFee={`Convenience fee $${props.ghaFwdConfig.convenience_fee_usd}  X ${props.cartCalculations.itemsCount} AWBS:`}
                            applyEwallet={props.applyEwalletBalance && props.paymentType === PaymentType.INVOICE_PAYMENT}
                            eWalletAmount={props.ewalletBalance.balance.toString()}
                            paymentType={ PaymentType.E_WALLET_PAYMENT }
                          />
                        </div>
                      }
                    />
                  }
                  {props.ghaFwdConfig && props.ghaFwdConfig.other_payment_allowed === 'yes' &&
                    <div>
                      <div className={paymentPageStyles.formControlGhaWrapper} >
                        <FormControlLabel
                          value={PaymentType.ALTERNATIVE_PAYMENT}
                          control={<Radio color="primary" />}
                          label={<div className={paymentPageStyles.radioLabels}>Other Payment Method</div>}
                        />
                        <Select
                          native
                          value={props.paymentInfoSelect}
                          onChange={(event: any) => props.handleChange(event, 'paymentInfoSelect')}
                          inputProps={{
                            name: 'company',
                            id: 'company',
                            className: classes.styleInputProps
                          }}
                          className={`${commonStyles.outlineInput} ${classes.select}`}
                          variant="outlined"
                        >
                          <option value={0} />
                          {payOptions}
                        </Select>
                        <span></span>
                      </div>
                      <div className={paymentPageStyles.padding}></div>
                      {props.paymentInfoSelect === 'other' &&
                        <div className={`${commonStyles.inputLabelWrapper}`}>
                          <label className={commonStyles.inputLabel}> Specify payment method </label>
                          <TextField
                            id="outlined-helperText"
                            className={`${commonStyles.outlineInput} ${classes.paymentInfo}`}
                            error={props.paymentType === PaymentType.ALTERNATIVE_PAYMENT && !props.paymentInfo}
                            value={props.paymentInfo}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => props.handleChange(event, 'paymentInfo')}
                            variant="outlined"
                            onClick={props.handleClickTextField}
                          />
                        </div>
                      }
                    </div>
                  }
                </RadioGroup>
              </FormControl>
            }
            {props.userRole === UserRoleType.GHA &&
              <div>
                <RadioGroup
                  aria-label="payment_method"
                  name="payment_method"
                  value={props.paymentType}
                  onChange={props.handleChangePaymentType}
                  className={commonStyles.w100}
                >
                  {props.ghaFwdConfig && props.ghaFwdConfig.pay_by_invoice_allowed &&
                    <FormControlLabel
                      value={PaymentType.INVOICE_PAYMENT}
                      control={<Radio color="primary" />}
                      className={`${classes.formControlLabelAfter} ${classes.formControlLabel}`}
                      classes={{ label: commonStyles.w100 }}
                      disabled={disableAccountPayment()}
                      label={
                        <div className={paymentPageStyles.itemsWrapper}>
                          <div className={[paymentPageStyles.radioLabels, classes.ghaLabel, disableAccountPayment() ? paymentPageStyles.disabledLabelColor : ''].join(' ')}>
                            <div>Pay via {props.fwdInvoiceBalance.accountType}</div>
                          </div>
                          <PaymentDetailsCredit
                            due={formatCurrency(props.due, 2)}
                            items={props.cartCalculations.itemsCount}
                            totalPay={formatCurrency(totalPayInvoicePayment, 2)}
                            disabled={disableAccountPayment()}
                            fwdInvoiceBalance={props.fwdInvoiceBalance.balance}
                            totalConvenience={formatCurrency(totalConvenienceInvoicePayment, 2)}
                            textConvenienceFee={`Convenience fee $${props.ghaFwdConfig.convenience_fee_usd}  X ${props.cartCalculations.itemsCount} AWBS:`}
                            type={props.userRole}
                            paymentType={ PaymentType.INVOICE_PAYMENT }
                          />
                        </div>
                      }
                    />
                  }
                  <div className={paymentPageStyles.formControlGhaWrapper} >
                    <FormControlLabel
                      value={PaymentType.ALTERNATIVE_PAYMENT}
                      control={<Radio color="primary" />}
                      label={<div className={paymentPageStyles.radioLabels}>Other Payment Method</div>}

                    />
                    <Select
                      native
                      value={props.paymentInfoSelect}
                      onChange={(event: any) => props.handleChange(event, 'paymentInfoSelect')}
                      inputProps={{
                        name: 'company',
                        id: 'company',
                        className: classes.styleInputProps
                      }}
                      className={`${commonStyles.outlineInput} ${classes.select}`}
                      variant="outlined"
                    >
                      <option value={0} />
                      {payOptions}
                    </Select>
                    <span></span>
                  </div>
                  <div className={paymentPageStyles.padding}></div>
                  {props.paymentInfoSelect === 'other' &&
                    <div className={`${commonStyles.inputLabelWrapper}`}>
                      <label className={commonStyles.inputLabel}> Specify payment method </label>
                      <TextField
                        id="outlined-helperText"
                        className={`${commonStyles.outlineInput} ${classes.paymentInfo}`}
                        error={props.paymentType === PaymentType.ALTERNATIVE_PAYMENT && !props.paymentInfo}
                        value={props.paymentInfo}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => props.handleChange(event, 'paymentInfo')}
                        variant="outlined"
                        onClick={props.handleClickTextField}
                      />
                    </div>
                  }
                  {props.paymentInfoSelect == 'eWallet' &&
                    <div className={classes.balanceContainer}>
                      <Typography className={classes.balanceText}>
                        Available Balance:
                      </Typography>
                      <Typography>{props.ewalletBalance.balance}</Typography>
                    </div>
                  }


                </RadioGroup>

              </div>

            }
            {props.paymentType !== PaymentType.CREDIT_CARD &&
              <div className={paymentPageStyles.buttonsWrapper}>

                {!props.manualEntryEdit.isEditMode &&
                  <Button variant='contained' color='primary' disabled={disableButton} className={classes.button} onClick={() => props.handlePay(true)}>{props.userRole === UserRoleType.FORWARDER ? 'Update' : 'Update & Generate PO'}</Button>
                }
                {props.disableButton && <CircularProgress className={classes.progress} />}
                {props.userRole === UserRoleType.GHA && props.manualEntryEdit.isEditMode &&
                  <Fragment>
                    <Button variant='contained' color='primary' className={classes.button} disabled={disableButton} onClick={props.openNoPoPayConfirmation} >Update & Exit</Button>
                    <Button variant='contained' color='primary' className={classes.button} disabled={disableButton} onClick={() => props.handlePay(false, undefined, true)}>Update Go to PO</Button>
                  </Fragment>
                }

              </div>
            }
          </Fragment>
        }

        {/* props.due === 0 */}
        <div className={paymentPageStyles.divButtons}>
          {props.isGeneratePickUpOrder && !props.manualEntryEdit.isEditMode && !props.comat &&
            <Button variant='contained' disabled={props.disableButton} color='primary' className={classes.mt5} onClick={() => props.handlePay(true)}>Generate Pick Up Order</Button>
          }
          {/* Go to PO page only for ME process */}
          {props.isGeneratePickUpOrder && props.userRole === UserRoleType.GHA && props.manualEntryEdit.isEditMode &&
            <Button variant='contained' color='primary' className={`${classes.mt5} ${classes.button}`} onClick={props.redirectToPickupOrder}>Go to Pickup Order</Button>
          }

        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    manualEntryEdit: state.manualEntryEdit
  };
};

export default withStyles(styles)(connect(mapStateToProps, {})(paymentPage));
